// Add calendly iframe with correct link based on email from url params
document.addEventListener('DOMContentLoaded', async () => {
    const container = document.getElementById('calendly-target');
    if (!container) return;

    // Show loading spinner
    showLoadingSpinner(container);

    // One-time guard stops re-runs from SPA re-renders, Shopify section reloads, HMR, duplicate script tags, etc.
    if (container.dataset.calInitDone === '1') return;
    container.dataset.calInitDone = '1';

    // Build email param from hashed email in url params
    const urlParams = new URLSearchParams(window.location.search);
    let email = '';
    const hashedEmail = urlParams.get('email') || '';
    try { if (hashedEmail) email = atob(hashedEmail); } catch { }

    // Get URL from centralized function (isEmailClickPage=true for this page)
    const desiredUrl = await window.CalendlyUrl.getUrl({ email: email, isEmailClickPage: true });

    // Store so we can enforce it
    container.dataset.calDesiredUrl = desiredUrl;

    // Remove any stray Calendly iframes on the page (from other scripts)
    document.querySelectorAll('iframe[src*="calendly.com"]').forEach((f) => f.remove());

    // Mount YOUR iframe (no widget.js needed)
    mountCalendlyIframe(container, desiredUrl);

    // If some other script tries to add its own iframe later, replace it
    const mo = new MutationObserver((mutations) => {
        for (const m of mutations) {
            m.addedNodes.forEach((n) => {
                if (n.nodeType === 1) {
                    // any calendly iframe anywhere
                    n.querySelectorAll?.('iframe[src*="calendly.com"]').forEach((f) => {
                        const wanted = container.dataset.calDesiredUrl;
                        if (f.src !== wanted) {
                            console.warn('Overriding unexpected Calendly iframe src:', f.src, '→', wanted);
                            f.src = wanted;
                        }
                    });
                    // or if a whole iframe was directly added
                    if (n.tagName === 'IFRAME' && n.src?.includes('calendly.com')) {
                        const wanted = container.dataset.calDesiredUrl;
                        if (n.src !== wanted) n.src = wanted;
                    }
                }
            });
        }
    });
    mo.observe(document.documentElement, { childList: true, subtree: true });

    function showLoadingSpinner(parent) {
        parent.innerHTML = `
            <div class="calendly-loading">
                <span id="rotating-text">Setting things up...</span>
                <div class="spinner"></div>            
            </div>
        `;
        const messages = [
            'Setting things up...',
            'Checking availability...',
            'Almost ready to go...'
        ];
        let i = 0;
        const textEl = parent.querySelector('#rotating-text');
        parent._spinnerInterval = setInterval(() => {
            i = (i + 1) % messages.length;
            if (textEl) textEl.textContent = messages[i];
        }, 2000);
    }


    function mountCalendlyIframe(parent, url) {
        const iframe = document.createElement('iframe');
        iframe.src = url;
        iframe.width = '100%';
        iframe.height = '700';
        iframe.frameBorder = '0';
        iframe.referrerPolicy = 'no-referrer-when-downgrade';
        iframe.style.opacity = '0';
        iframe.style.transition = 'opacity .25s ease';

        parent.appendChild(iframe);

        const reveal = () => {
            clearInterval(parent._spinnerInterval);
            parent.querySelector('.calendly-loading')?.remove();
            iframe.style.opacity = '1';
        };

        iframe.addEventListener('load', reveal, { once: true });

        // safety fallback if 'load' never fires
        const safety = setTimeout(reveal, 8000);
        iframe.addEventListener('load', () => clearTimeout(safety), { once: true });
    }
});

// After book calendly, redirect to tool page
// window.addEventListener('message', function (e) {
//     // when calendly is booked
//     if (
//         e.data.event &&
//         e.data.event === 'calendly.event_scheduled'
//     ) {
//         // redirect to tool page by replacing param ec_view=calendly with ec_view=tool
//         const url = new URL(window.location.href);
//         url.searchParams.set('ec_view', 'tool');
//         url.searchParams.set('booked', 'true');
//         window.location.href = url.toString();
//     }
// });

// When click tool button, redirect to tool page with email param still intact
// document.addEventListener('DOMContentLoaded', () => {
//     const toolCta = document.getElementById('ec-tool-cta-calendly');
//     if (!toolCta) return;
//     toolCta.addEventListener('click', (e) => {
//         e.preventDefault();
//         const url = new URL(window.location.href);
//         url.searchParams.set('ec_view', 'tool');
//         window.location.href = url.toString();
//     });
// });